import React from 'react';
import { Toggle as ADToggle } from 'src/presentation/components/agent_desktop_components';

type ToggleProps = {
  debounceInterval?: number;
  disabled?: boolean;
  value: boolean;
  onChange: Function;
  'data-aid'?: string;
};

const Toggle = ({ 'data-aid': dataAid, debounceInterval, disabled = false, value, onChange }: ToggleProps) => {
  const toggleStatus = value ? 'enabled' : 'disabled';
  return (
    <ADToggle
      className={`admin-toggle-${toggleStatus}`}
      data-aid={dataAid}
      onChange={() => onChange(!value)}
      debounceInterval={debounceInterval}
      isDisabled={disabled}
      isEnabled={value}
    />
  );
};

export default Toggle;
